export enum SeturLoyaltySourceSystemTypes {
  SETUR = 'Setur',
  BEYOND = 'Beyond',
  DFS = 'DFS',
  SETUR_MOBIL_APP = 'SeturMobilApp',
  LOYALTY = 'Loyalty',
}
